export default __webpack_public_path__ + "static/media/count_bbi.3c8d20e5.mp3";